import * as React from 'react';
import { ThemeContext } from '../../context/theme.context';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { getEvents } from '../../services/events/event';
import { getPlan } from '../../services/ControlCenter/PlanServices';
import { loadingShow } from '../../App';
import TheTabComponent from './TheTabComponent';
import { memo, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  changeResetDataLoadingBoolenValue,
  setIsPlanSelected,
} from '../../redux/search.slice';
import { FcCancel, FcSearch, FcSettings } from 'react-icons/fc';
import { AiOutlineFilter } from 'react-icons/ai';
import GlobalDialog from '../../components/GlobalDialog';
import GanttSettings from '../CloudScheduler/GanttSettings';
import { GanttComponent } from '@syncfusion/ej2-react-gantt';
import { ButtonPropsModel } from '@syncfusion/ej2-react-popups';
import Message from '../../utils/Message/Message';
import { SyncFullOperations } from '../../services/MexServices/Orders/OrderService';
import { toast } from 'react-toastify';
const ERP_TYPE = process.env.REACT_APP_ERP_TYPE;
let eventDropDown = new DropDownListComponent({});
let planDropDown = new DropDownListComponent({});
interface IProps {}
var current_tab = 0;
let thePlanData: Array<any> = [];
const CloudPlanner: React.FC<IProps> = (props) => {
  let timezone_offset = useSelector(
    (state: any) => state.search.timezone_offset
  );
  const [eventsData, setEventsData] = React.useState<Array<any>>([]);
  const [planData, setPlanData] = React.useState<Array<any>>([]);

  const [settingsDialog, setsettingsDialog] = React.useState<boolean>(false);
  const [hideFilterDialog, sethideFilterDialog] =
    React.useState<boolean>(false);
  const [allowDragDrop, setAllowDragDrop] = React.useState<boolean>(false);
  const [dayWorkingTime, setdayWorkingTime] = React.useState<Array<any>>([]);

  const gantObj: GanttComponent = new GanttComponent({});
  const [allowSeg, setAllowSeg] = React.useState<boolean>(false);
  const context = useContext(ThemeContext);
  const dispatch = useDispatch();
  const [ResetData, setResetData] = useState<boolean>(false);
  const [isResetDataLoading, setisResetDataLoading] = useState<boolean>(false);
  const [resetDataToastinId, setresetDataToastinId]: any = useState(null);
  const [isDataResettingComponentHandle, setisDataResettingComponentHandle] =
    useState<boolean>(false);
  const reduxSearchS = useSelector((state: any) => state.search);
  useEffect(() => {
    if (reduxSearchS.isResetDataLoading && resetDataToastinId == null) {
      setresetDataToastinId(toast.loading('Data is resetting...'));
    }

    const fetchData = async () => {
      let theEventID = Number(localStorage.getItem('cs_event_dd_value'));
      let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
      await getEvent();
      if (theEventID !== 0 && thePlanID !== 0) {
        if (eventDropDown && eventDropDown !== null)
          eventDropDown.value = theEventID;
        loadingShow(true);
        onChangeEvents(false, {
          value: theEventID,
          plan_id: thePlanID,
          isTheSavedPlan: true,
        });
      } else {
        dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: 0,
          })
        );
      }
    };

    fetchData();
    setisDataResettingComponentHandle(reduxSearchS.isResetDataLoading);
    return () => {
      context.setPlanId(0);
    };
  }, []);
  useEffect(() => {
    setisDataResettingComponentHandle(reduxSearchS.isResetDataLoading);
    if (isDataResettingComponentHandle) {
      toast.update(resetDataToastinId, {
        render: 'Data Successfully Resetted',
        type: 'success',
        autoClose: 4000,
        isLoading: false,
      });
    }
  }, [reduxSearchS.isResetDataLoading]);

  const getPlans = async (event_id: Number) => {
    await getPlan(event_id).then((res: any) => {
      res.data.unshift({
        plan_name: '',
        ID: -1,
      });
      thePlanData = res.data;
      setPlanData(res.data);
    });
  };
  const getEvent = async () => {
    await getEvents().then((result) => {
      result.data.unshift({
        eventCode: '',
        eventId: -1,
      });

      setEventsData(result.data);
    });
  };

  let resetDataButton: ButtonPropsModel[] = [
    {
      buttonModel: { content: 'Yes' },
      click: () => {
        setResetData(false);
        resetDataFunction();
      },
    },
    {
      buttonModel: { content: 'No' },
      click: () => {
        setResetData(false);
      },
    },
  ];

  const resetDataFunction = () => {
    setisResetDataLoading(true);
    Message.success('Data is resetting...');
    dispatch(changeResetDataLoadingBoolenValue());
    setResetData(false);
    SyncFullOperations(timezone_offset)
      .then((result) => {
        if (result.status == 200) {
          toast.update(resetDataToastinId, {
            render: 'All is good',
            type: 'success',
            isLoading: false,
          });
          setisResetDataLoading(false);
          Message.success('Synced successfully...');
          dispatch(changeResetDataLoadingBoolenValue());
        }
      })
      .catch((err) => {
        loadingShow(false);
        Message.error('Sync failed!!!');
      });
  };

  const onChangeEvents = async (isFirst: boolean, args: any) => {
    loadingShow(true);
    localStorage.setItem('cs_event_dd_value', args.value);
    const eventId = args.value;
    await getPlans(eventId);
    const plan_id = thePlanData.length > 0 ? thePlanData[1]?.ID : null;
    if (eventId === -1) {
      localStorage.removeItem('cs_event_dd_value');
      localStorage.removeItem('cs_plan_dd_value');
      loadingShow(false);
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
      return;
    }
    if (thePlanData.length === 2 || args.isTheSavedPlan) {
      let thePlan = planData[1];
      if (args.isTheSavedPlan) {
        planDropDown && (planDropDown.value = args.plan_id);
        await onChangePlan(isFirst, { value: args.plan_id });
        return;
      }
      if (plan_id !== null) {
        localStorage.setItem('cs_plan_dd_value', plan_id);
        planDropDown && (planDropDown.value = plan_id);
        context.setPlanId(plan_id);
        dispatch(
          setIsPlanSelected({
            isOrderPlanSelected: true,
            isOpPlanSelected: true,
            planId: plan_id,
          })
        );
        if (isFirst) {
          context.setResourcesAllowChange(true);
          context.setMaterialAllowChange(true);
        }
      }
    } else {
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
    }
    loadingShow(false);
  };
  const onChangePlan = async (isFirst: boolean, args: any) => {
    loadingShow(true);
    localStorage.setItem('cs_plan_dd_value', args.value);
    if (-1 === args.value) {
      localStorage.removeItem('cs_plan_dd_value');
      context.setPlanId(0);
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: 0,
        })
      );
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
    } else {
      dispatch(
        setIsPlanSelected({
          isOrderPlanSelected: true,
          isOpPlanSelected: true,
          planId: args.value,
        })
      );
      context.setPlanId(args.value);
      if (isFirst) {
        context.setMaterialAllowChange(true);
        context.setResourcesAllowChange(true);
      }
    }
    loadingShow(false);
  };

  return (
    <div>
      <div
        className='header-cloud-scheduler-fixed'
        style={{
          marginRight: 30,
          marginTop: 30,
        }}
      >
        {ERP_TYPE == 'MEX' ? (
          <FcCancel
            title='Reload All Data'
            size={30}
            style={{ marginRight: 5 }}
            onClick={() => {
              if (isResetDataLoading || isDataResettingComponentHandle) {
                Message.error('Data is resetting...');
              } else {
                setResetData(true);
              }
            }}
          />
        ) : (
          <></>
        )}
        <FcSettings
          size={30}
          style={{ marginRight: 5 }}
          onClick={() => {
            setsettingsDialog(true);
          }}
        />
        {/* <AiOutlineFilter
            size={30}
            style={{ marginRight: 5 }}
            onClick={() => {
              sethideFilterDialog( true );
            }}
          /> */}
        {ResetData ? (
          <GlobalDialog
            showDialog={ResetData}
            setShowDialog={(val) => setResetData(val)}
            header='Reset data Message'
            width={'20%'}
            height={'20%'}
            hideDoneButton={true}
            content={'Are you sure to reset data ?'}
            buttons={resetDataButton}
          ></GlobalDialog>
        ) : null}
        {settingsDialog ? (
          <GlobalDialog
            showDialog={settingsDialog}
            setShowDialog={(val) => setsettingsDialog(val)}
            header='Gantt Settings'
            width={'500px'}
            hideDoneButton={false}
            content={() => {
              return (
                <GanttSettings
                  allowDragDrop={allowDragDrop}
                  setAllowDragDrop={(val) => setAllowDragDrop(val)}
                  allowSeg={allowSeg}
                  gantObj={gantObj}
                  dayWorkingTime={dayWorkingTime}
                  setAllowSeg={(val) => setAllowSeg(val)}
                  setDayWorkingTime={(val) => setdayWorkingTime(val)}
                />
              );
            }}
          ></GlobalDialog>
        ) : null}

        <div className='cloud-scheduler-input'>
          <DropDownListComponent
            placeholder='Event'
            ref={(el: DropDownListComponent) => (eventDropDown = el)}
            dataSource={eventsData}
            fields={{ text: 'eventCode', value: 'eventId' }}
            value={0}
            onChange={onChangeEvents.bind(this, true)}
            dataBound={() => {}}
          />
        </div>
        <div className='cloud-scheduler-input'>
          <DropDownListComponent
            ref={(el: DropDownListComponent) => (planDropDown = el)}
            placeholder='Plan'
            dataSource={planData}
            fields={{ text: 'plan_name', value: 'ID' }}
            onChange={onChangePlan.bind(this, true)}
          />
        </div>
      </div>
      <TheTabComponent />
    </div>
  );
};

export default memo(CloudPlanner);
